import React, { useState } from "react";

const FieldEditor = ({ availableFields, changes, onChange, highlightFields = [] }) => {
  const [selectedField, setSelectedField] = useState("");
  const [fieldValue, setFieldValue] = useState("");

  const handleAdd = () => {
    if (selectedField && fieldValue.trim()) {
      onChange({
        ...changes,
        [selectedField]: fieldValue.trim(),
      });
      setSelectedField("");
      setFieldValue("");
    }
  };

  const handleRemove = (field) => {
    const updated = { ...changes };
    delete updated[field];
    onChange(updated);
  };

  const handleChange = (field, value) => {
    onChange({
      ...changes,
      [field]: value,
    });
  };

  const sortedFields = [...availableFields].sort((a, b) => {
    const aHighlight = highlightFields.includes(a);
    const bHighlight = highlightFields.includes(b);
    if (aHighlight && !bHighlight) return -1;
    if (!aHighlight && bHighlight) return 1;
    return a.localeCompare(b);
  });

  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <select
          value={selectedField}
          onChange={(e) => setSelectedField(e.target.value)}
          className="flex-1 p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none text-sm"
        >
          <option value="">انتخاب فیلد...</option>
          {sortedFields
            .filter((field) => !changes[field])
            .map((field) => {
              const isHighlight = highlightFields.includes(field);
              return (
                <option
                  key={field}
                  value={field}
                  className={isHighlight ? "bg-yellow-900 font-bold" : ""}
                >
                  {isHighlight ? "⭐ " : ""}{field}
                </option>
              );
            })}
        </select>
        <input
          type="text"
          value={fieldValue}
          onChange={(e) => setFieldValue(e.target.value)}
          placeholder="مقدار..."
          className="w-40 p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-green-500 focus:outline-none text-sm"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAdd();
            }
          }}
        />
        <button
          onClick={handleAdd}
          disabled={!selectedField || !fieldValue.trim()}
          className="px-4 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white rounded-lg transition duration-200 text-sm whitespace-nowrap"
        >
          افزودن
        </button>
      </div>

      {Object.keys(changes).length > 0 ? (
        <div className="bg-gray-900 rounded-lg p-3 space-y-2 max-h-96 overflow-y-auto">
          {Object.entries(changes).map(([field, value]) => {
            const isHighlight = highlightFields.includes(field);
            return (
              <div
                key={field}
                className={`flex items-center gap-2 bg-gray-800 rounded p-2 border-l-4 ${
                  isHighlight ? "border-yellow-500" : "border-gray-600"
                }`}
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-gray-400 text-xs">{field}</span>
                    {isHighlight && (
                      <span className="text-xs px-2 py-0.5 rounded bg-yellow-900/50 text-yellow-300">
                        مهم
                      </span>
                    )}
                  </div>
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(field, e.target.value)}
                    className="w-full p-2 bg-gray-900 border border-gray-600 rounded text-white text-sm focus:border-green-500 focus:outline-none"
                  />
                </div>
                <button
                  onClick={() => handleRemove(field)}
                  className="text-red-400 hover:text-red-300 hover:bg-red-900/30 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0"
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-500 text-sm text-center py-4">
          هنوز فیلدی اضافه نشده است
        </p>
      )}
    </div>
  );
};

export default FieldEditor;